__turbopack_context__.v({
  "crumbCurrent": "_3TUUKG_crumbCurrent",
  "crumbInert": "_3TUUKG_crumbInert",
  "crumbLink": "_3TUUKG_crumbLink",
  "crumbs": "_3TUUKG_crumbs",
  "sep": "_3TUUKG_sep",
});
